/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Hangi_PazaryerleriInputs */

const tr_faq_q_hangi_pazaryerleri = /** @type {(inputs: Faq_Q_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hangi pazaryerleriyle çalışıyor?`)
};

const en_faq_q_hangi_pazaryerleri = /** @type {(inputs: Faq_Q_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which platforms are supported?`)
};

const de_faq_q_hangi_pazaryerleri = /** @type {(inputs: Faq_Q_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Plattformen werden unterstützt?`)
};

const ru_faq_q_hangi_pazaryerleri = /** @type {(inputs: Faq_Q_Hangi_PazaryerleriInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какие площадки поддерживаются?`)
};

/**
* | output |
* | --- |
* | "Which platforms are supported?" |
*
* @param {Faq_Q_Hangi_PazaryerleriInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_hangi_pazaryerleri = /** @type {((inputs?: Faq_Q_Hangi_PazaryerleriInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Hangi_PazaryerleriInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_hangi_pazaryerleri(inputs)
	if (locale === "de") return de_faq_q_hangi_pazaryerleri(inputs)
	if (locale === "ru") return ru_faq_q_hangi_pazaryerleri(inputs)
	return tr_faq_q_hangi_pazaryerleri(inputs)
});